export default "__VITE_ASSET__Dg14HGhb__"